// extracted by mini-css-extract-plugin
export default {"toolboxContainer":"Toolbox_toolboxContainer__FD8WD"};